import { AiResponseAction } from '@/common/api/models.pleased';
import { switcher } from '../switcher';
import { TransactionType } from '@/common/config';
import { AiActionShowSelectorTypes } from './AiService.types';
import { ExternalTransactionType } from '../../enum/ExternalTransactionType';

const aiActionShowSelectorSwitcher = switcher<
  AiResponseAction,
  AiActionShowSelectorTypes
>()
  .when(AiResponseAction.SHOW_DEPOSIT_SELECTOR, () => ({
    type: TransactionType.Deposit,
    status: [
      ExternalTransactionType.DEPOSITS_PENDING,
      ExternalTransactionType.DEPOSITS_FAILED,
      ExternalTransactionType.DEPOSITS_SUCCESSFUL,
    ],
  }))
  .when(AiResponseAction.SHOW_PENDING_DEPOSIT_SELECTOR, () => ({
    type: TransactionType.Deposit,
    status: ExternalTransactionType.DEPOSITS_PENDING,
  }))
  .when(AiResponseAction.SHOW_FAILED_DEPOSIT_SELECTOR, () => ({
    type: TransactionType.Deposit,
    status: ExternalTransactionType.DEPOSITS_FAILED,
  }))
  .when(AiResponseAction.SHOW_SUCCESSFUL_DEPOSIT_SELECTOR, () => ({
    type: TransactionType.Deposit,
    status: ExternalTransactionType.DEPOSITS_SUCCESSFUL,
  }))
  .when(AiResponseAction.SHOW_WITHDRAWAL_SELECTOR, () => ({
    type: TransactionType.Withdrawal,
    status: [
      ExternalTransactionType.WITHDRAWALS_PENDING,
      ExternalTransactionType.WITHDRAWALS_FAILED,
      ExternalTransactionType.WITHDRAWALS_SUCCESSFUL,
    ],
  }))
  .when(AiResponseAction.SHOW_PENDING_WITHDRAWAL_SELECTOR, () => ({
    type: TransactionType.Withdrawal,
    status: ExternalTransactionType.WITHDRAWALS_PENDING,
  }))
  .when(AiResponseAction.SHOW_FAILED_WITHDRAWAL_SELECTOR, () => ({
    type: TransactionType.Withdrawal,
    status: ExternalTransactionType.WITHDRAWALS_FAILED,
  }))
  .when(AiResponseAction.SHOW_SUCCESSFUL_WITHDRAWAL_SELECTOR, () => ({
    type: TransactionType.Withdrawal,
    status: ExternalTransactionType.WITHDRAWALS_SUCCESSFUL,
  }))
  .none(type => console.error('[TRANSACTION_TYPE]: Not identified', { type }));

export const isAiActionShowSelector = (action: AiResponseAction) => {
  return aiActionShowSelectorSwitcher.test(action);
};

export const getAiActionSelectorTypes = (action: AiResponseAction) => {
  return aiActionShowSelectorSwitcher.match(action);
};
